module.exports = __webpack_public_path__ + "img/9788954622578.81f13754.jpg";